// extracted by mini-css-extract-plugin
module.exports = {"container":"ProcessOrder_container__1EAbH","finishButton":"ProcessOrder_finishButton__2TDL0","title":"ProcessOrder_title__3gI4u","cancel":"ProcessOrder_cancel__35SIh"};